module.exports = __webpack_public_path__ + "static/media/profile-img.bc836a10.jpg";